import React, { FC } from 'react';
import classNames from 'classnames';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

// @ts-expect-error with loading image
import smile1 from '../../../assets/images/smile-1.png';
// @ts-expect-error with loading image
import smile2 from '../../../assets/images/smile-2.png';
// @ts-expect-error with loading image
import smile3 from '../../../assets/images/smile-3.png';
// @ts-expect-error with loading image
import smile4 from '../../../assets/images/smile-4.png';
// @ts-expect-error with loading image
import smile5 from '../../../assets/images/smile-5.png';

import Paragraph from '../../ui/Typography/Paragraph';

import { $l } from '../../../locales';

import css from './style.module.scss';
import {
  CHAT_RATING_LIST,
  RATING_1,
  RATING_2,
  RATING_3,
  RATING_4,
  RATING_5,
} from '../../../constants/qaAttributes';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IRatingProps {
  rateSelect: (value: number) => void;
  value?: number;
}

const rateOptions = [
  { value: 1, src: smile1, alt: 'Rating 1', text: $l('RATING_1'), qaId: RATING_1 },
  { value: 2, src: smile2, alt: 'Rating 2', text: $l('RATING_2'), qaId: RATING_2 },
  { value: 3, src: smile3, alt: 'Rating 3', text: $l('RATING_3'), qaId: RATING_3 },
  { value: 4, src: smile4, alt: 'Rating 4', text: $l('RATING_4'), qaId: RATING_4 },
  { value: 5, src: smile5, alt: 'Rating 5', text: $l('RATING_5'), qaId: RATING_5 },
];

const Rating: FC<IRatingProps> = ({ rateSelect, value }) => (
  <List gap="4" {...setQaAttribute(CHAT_RATING_LIST)}>
    <List direction="row" align="center" gap="12">
      {rateOptions.map((rateOption) => (
        <List key={rateOption.value} align="center">
          <button
            className={classNames(css.rating__button, {
              [css.isChecked]: rateOption.value === value,
            })}
            onClick={() => rateSelect(rateOption.value)}
            {...setQaAttribute(rateOption.qaId)}
          >
            <img className={css.rating__img} src={rateOption.src} alt={rateOption.alt} />
          </button>
        </List>
      ))}
    </List>
    <List direction="row" justify="space-between">
      <Paragraph fontSize="12" lineHeight="17" letterSpacing="0_17">
        {$l('RATING_1')}
      </Paragraph>
      <Paragraph fontSize="12" lineHeight="17" letterSpacing="0_17">
        {$l('RATING_5')}
      </Paragraph>
    </List>
  </List>
);

export default Rating;
